// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".planboard-calendar[data-v-7e25f49e] {\n  border-top: 1px solid #d3d3d3;\n  background: #eff3f7;\n  padding-top: 30px;\n  position: absolute;\n  overflow-y: scroll;\n  width: 100%;\n  height: calc(100vh - 190px);\n}\n", ""]);
// Exports
module.exports = exports;
